import React from 'react';
import PropTypes from 'prop-types';
import { I18n, Translate } from 'react-redux-i18n';
import { Icon } from 'front-onceforall-core';
import { DOCUMENT_CATEGORY } from '../../../utils/constant';
import DocumentGrid from './DocumentGrid';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ProjectDocumentsFormView(props) {
  function renderDocumentGrid(category) {
    return /*#__PURE__*/_jsx(DocumentGrid, {
      onChangeLabel: props.onChangeLabel,
      onRemoveCustom: props.onRemoveCustom,
      onCheckboxChange: props.onCheckboxChange,
      onAddCustom: props.onAddCustom,
      isOnEdit: props.isOnEdit,
      documentTypes: props.documentTypes,
      category: category
    });
  }
  if (props.loading) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [props.displayEditMessage && /*#__PURE__*/_jsxs("div", {
      className: "box card flex-container",
      children: [/*#__PURE__*/_jsx("div", {
        className: "secondary",
        children: /*#__PURE__*/_jsx(Icon, {
          icon: "info"
        })
      }), /*#__PURE__*/_jsx("div", {
        "data-id": "edit-message",
        children: I18n.t('project.edit.enabledTooltip')
      })]
    }), /*#__PURE__*/_jsxs("form", {
      onSubmit: props.onSubmit,
      children: [renderDocumentGrid(DOCUMENT_CATEGORY.MANDATORY), renderDocumentGrid(DOCUMENT_CATEGORY.OPTIONAL), renderDocumentGrid(DOCUMENT_CATEGORY.SPECIFIC), /*#__PURE__*/_jsx("div", {
        className: "actions col-12 inline-container space-between",
        children: /*#__PURE__*/_jsxs("button", {
          className: "large secondary inline-container",
          type: "submit",
          children: [/*#__PURE__*/_jsx(Translate, {
            value: "action.confirm"
          }), /*#__PURE__*/_jsx(Icon, {
            icon: "check"
          })]
        })
      })]
    })]
  });
}
ProjectDocumentsFormView.defaultProps = {
  displayEditMessage: false,
  isOnEdit: false,
  loading: true,
  documentTypes: []
};
ProjectDocumentsFormView.propTypes = {
  onChangeLabel: PropTypes.func.isRequired,
  onRemoveCustom: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  onAddCustom: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  displayEditMessage: PropTypes.bool,
  isOnEdit: PropTypes.bool,
  loading: PropTypes.bool,
  documentTypes: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    requiredInProject: PropTypes.bool.isRequired
  }))
};
export default ProjectDocumentsFormView;